import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { UPLOAD_DIALOG_STYLES, UPLOAD_DIALOG_COLORS } from '../../../../../common/styles/dialogStyles';

interface UploadProgressProps {
  progress: number;
}

export const UploadProgress: React.FC<UploadProgressProps> = ({ progress }) => (
  <Box>
    <Typography variant="body2" sx={{ mb: 1, color: UPLOAD_DIALOG_COLORS.textSecondary }}>
      Uploading documents...
    </Typography>
    <LinearProgress variant="determinate" value={progress} sx={UPLOAD_DIALOG_STYLES.progressBar} />
    <Typography variant="caption" sx={{ color: UPLOAD_DIALOG_COLORS.textMuted, mt: 1 }}>
      {Math.round(progress)}% complete
    </Typography>
  </Box>
);

export default UploadProgress;
